<template>
  <div class="row">
    <div class="col-12 col-md-6 mb-2">
      <b-form-group label-for="address" class="mb-2">
        <template #label>
          <label class="akkurate-dark small" for="address">Address <star></star></label>
        </template>
        <b-form-textarea class="mt-1 fields" id="address" v-model="form.address" placeholder="Enter Address..."></b-form-textarea>
      </b-form-group>

    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="digital_address">Digital Address</label>
      <b-form-group id="digital_address" label-for="digital_address" class="relative">
        <div class="position-relative">
          <b-form-input class="mt-1 field-container fields pr-10" type="text" placeholder="Enter Digital Address" v-model="form.digital_address"></b-form-input>


          <b-button class="position-absolute top-50 end-0 translate-middle-y px-3 py-1 akkurate-green-bg btn" @click="showMapPicker = true">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" />
          </b-button>
        </div>

        <errors v-if="form.errors.digital_address">
          {{ form.errors.digital_address[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="region">Region <star></star></label>
      <b-form-group id="region" label-for="region">
        <multiselect class="mt-1 field-container" v-model="form.region" :options="region_options" label="name">
        </multiselect>
        <errors v-if="form.errors.regions">
          {{ form.errors.regions[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="home_town">Home Town</label>
      <b-form-group id="home_town" label-for="home_town">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Home Town" v-model="form.home_town"></b-form-input>
        <errors v-if="form.errors.home_town">
          {{ form.errors.home_town[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="nearest_landmark">Nearest Landmark</label>
      <b-form-group id="nearest_landmark" label-for="nearest_landmark">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Home Town" v-model="form.nearest_landmark"></b-form-input>
        <errors v-if="form.errors.nearest_landmark">
          {{ form.errors.nearest_landmark[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="branch">Branch <star></star></label>
      <b-form-group id="branch" label-for="branch">
        <multiselect class="mt-1 field-container" label="name" v-model="form.branch" :options="branch_options">
        </multiselect>
        <errors v-if="form.errors.branch">
          {{ form.errors.branch[0] }}
        </errors>
      </b-form-group>
    </div>

    <MapAddressPicker v-model="showMapPicker" @selected="setDigitalAddress" @coords="setCoords" :initialCoords="{ lat: form.latitude, lng: form.longitude }" />

  </div>
</template>
<script>
import MapAddressPicker from "@/views/components/MapAddressPicker.vue";
import Multiselect from "vue-multiselect";
export default {
  name: "AddressView",
  props: ['form', 'region_options', 'branch_options', 'add_or_edit'],
  data() {
    return {
      showMapPicker: false,
    };
  },
  components: {
    Multiselect,
    MapAddressPicker
  },
  methods: {

    setDigitalAddress(address) {
      this.form.digital_address = address
    },
    setCoords({ lat, lng }) {
      this.form.latitude = lat;
      this.form.longitude = lng;

      console.log("Coords set to:", this.form.latitude, this.form.longitude);
    }
  }
}
</script>